export function checkSA(profile) {
    if (profile && profile.role === 'SuperAdmin') return true;
    return false;
}

export function checkA(profile) {
    if (profile && profile.role === 'Admin') return true;
    return false;
}

export function getFileName(downloadURL) {
    try {
        let fn = decodeURI(downloadURL).split('/').pop()
        fn = fn.split('?alt=')[0];
        let final = fn.split('%2F');
        final = final[final.length - 1]
        return final || fn || downloadURL

    } catch (e) {
        return downloadURL
    }
}

export function getCollection(profile, list) {
    if (profile && profile.organization && profile.organization.id)
        return `organizations/${profile.organization.id}/${list}`;
    return 'Jassu'
}

export function getRoom(profile, roomId) {
    if (profile && profile.organization && profile.organization.id)
        return `organizations/${profile.organization.id}/chats/${roomId}/messages`;
    return 'Jassu'
}